import { render, staticRenderFns } from "./DeliveryPage.vue?vue&type=template&id=fa1e67be&scoped=true&"
import script from "./DeliveryPage.vue?vue&type=script&lang=js&"
export * from "./DeliveryPage.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryPage.vue?vue&type=style&index=0&id=fa1e67be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa1e67be",
  null
  
)

export default component.exports